<template>
  <div>
    <el-dialog
      title="Add Bank Details"
      :visible.sync="dialogVisible"
      width="30%"
      class="headercolor"
    >
      <AddBankpopup />
    </el-dialog>
    <b-card>
      <div class="flex justify-between">
        <base-button
          outline
          @click="dialogVisible = true"
          type="primary"
          class="flex px-3 py-1 mx-1"
        >
          <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Add Bank
          Details
        </base-button>
        <!-- <base-button outline type="primary" class="flex px-3 py-1 mx-1">
          <download-excel
            class="mr-1 flex"
            default-value=""
            :fetch="fetchData"
            :fields="json_fields"
            worksheet="My Worksheet"
            name="Order_Details.xls"
          >
            <feather-icon icon="UploadIcon" class="mr-2 cust-HW"></feather-icon
            >Export All
          </download-excel>
        </base-button> -->
      </div>
      <div>
        <el-table
          class="table-responsive table-flush mt-6"
          header-row-class-name="thead-light table-th-color"
          :data="get_volunteerbooking.record"
          border
        >
          <el-table-column
            label="Sr. No"
            type="index"
            :index="indexMethod"
            width="60px"
          ></el-table-column>
          <el-table-column
            label="Session ID"
            prop="sessionid"
            min-width="150px"
          >
            <template v-slot="{ row }">
              <span class="text-purple font-medium underline">{{
                row._id
              }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Session Date"
            min-width="140px"
            prop="createDate"
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{
                formattedDate(row.date)
              }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Name" min-width="140px" prop="name">
            <template v-slot="{ row }">
              <b-media no-body class="align-items-center">
                <b-media-body>
                  <span class="font-medium name mb-0 text-sm"
                    >{{ row.userId.firstname }} {{ row.userId.lastname }}
                  </span>
                </b-media-body>
              </b-media>
            </template>
          </el-table-column>

          <el-table-column label="Gross Amount" min-width="140px" prop="gross">
            <template v-slot="{ row }">
              <span class="font-medium text-center">₹{{ row.price }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="share"
            label="Caregiver's Share"
            width="180"
            class=""
          >
            <template v-slot="{ row }">
              <span class="font-medium text-center"
                >₹{{ (row.price * 10) / 100 }}</span
              >
            </template>
          </el-table-column>

          <el-table-column label="Net Amount" min-width="150px" prop="amount">
            <template v-slot="{ row }">
              <span
                class=""
                v-html="`₹${row.price - (row.price * 10) / 100}`"
              ></span>
            </template>
          </el-table-column>

          <el-table-column
            label=" Session Status"
            min-width="180px"
            prop="status"
          >
            <template v-slot="{ row }">
              <span
                v-if="row.status == 'Upcoming'"
                class="text-danger font-medium"
                >{{ row.status }}</span
              >
              <span v-else class="text-success font-medium">{{
                row.status
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Withdraw"
            min-width="150px"
            v-slot="{ row }"
            prop="status"
          >
            <base-button
              v-if="!row.withdrawalId && !row.withdrawalRequested"
              type="primary"
              class="py-1 mx-1 flex items-center h-10 ml-4"
              @click="handleStatus(row)"
              :disabled="row.status == 'Upcoming'"
            >
              Request
            </base-button>
            <span
              v-else-if="row.withdrawalRequested"
              :class="{
                'text-danger': row.withdrawalId.withdrawStatus == 'Cancelled',
                'text-success': row.withdrawalId.withdrawStatus == 'Approved',
              }"
              class="flex justify-center font-medium underline"
              >{{ row.withdrawalId.withdrawStatus }}</span
            >
          </el-table-column>
        </el-table>
      </div>
      <b-card-footer class="py-4 d-flex justify-content-end">
        <base-pagination
          @change="handlePageChange"
          v-model="currentPage"
          :per-page="perPage"
          :total="total_row"
        ></base-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui";
import earn from "../../../../volunteer-view/layouts/components/earn";
import { mapState } from "vuex";
import AddBankpopup from "./AddBankpopup.vue";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    AddBankpopup,
  },
  data() {
    return {
      earn,
      dialogVisible: false,
      currentPage: 1,
      perPage: 10,
      total_row: 1,
    };
  },
  methods: {
    handlePageChange(value) {
      this.currentPage = value;
      try {
        this.init();
      } catch (error) {}
    },
    async init() {
      const payload = {
        volunteerId: this.get_volunteerbyuserId[0]._id,
        limit: 10,
        offset: this.currentPage - 1,
      };
      try {
        await this.$store.dispatch("respitecare/getvolunteerbooking", payload);
        this.total_row = this.get_volunteerbooking.totalCount;
      } catch (error) {
        console.log(error);
      }
    },
    // createWithdrawal
    async handleStatus(row) {
      let payload = {
        volunteerId: row.volunteerId,
        userId: row.userId._id,
        withdrawAmt: row.price,
        comment: "Test Comment",
      };

      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch(
          "respitecare/createWithdrawal",
          payload
        );
        if (data.code === 200) {
          let payload2 = {
            _id: row._id,
            withdrawalRequested: true,
            withdrawalId: data.data._id,
          };
          await this.$store.dispatch("respitecare/editbooking", payload2);
          this.init();
          this.$swal.fire({
            title: "Request Sent!",
            text: "Your withdraw request sent successfully!",
            icon: "success",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    async fetchData() {
      let payload = {
        limit: this.total_row,
      };

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch(
          "respitecare/getvolunteerbooking",
          payload
        );
        if (data.code == 200) {
          loader.close();
          this.$swal({
            html: `<p class="text-center">Data has been successfully exported!</p>`,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
          return data.data.record;
        }
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    formattedDate(dateData) {
      const date = new Date(dateData);
      const formattedDate = `${date.getDate().toString().padStart(2, "0")}-${(
        date.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}-${date.getFullYear()}`;
      return formattedDate;
    },
    indexMethod(index) {
      return this.perPage * (this.currentPage - 1) + index + 1;
    },
  },
  computed: {
    ...mapState("respitecare", {
      get_volunteerbooking: "get_volunteerbooking",
      get_volunteerbyuserId: "get_volunteerbyuserId",
    }),
    json_fields() {
      return {
        Session_Id: "_id",
        Date: {
          field: "createdAt",
          callback: (date) => {
            return new Date(date).toDateString();
          },
        },
        Customer_Name: "userId.name",
        Customer_Email: "userId.email",
        Customer_Mobile: "userId.phoneNumber",
        Price: "price",
        Session_status: "status",
      };
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.text-purple {
  color: #4f0a4b;
}
.text-blue {
  color: rgb(0 51 255);
}
.text-yellow {
  color: rgb(255, 208, 0);
}
.cust-space {
  padding: 10px 29px;
}
.headercolor .el-dialog__header {
  background: #4f0a4b !important;
}
.headercolor .el-dialog__title {
  color: white;
}
</style>
